// extracted by mini-css-extract-plugin
export default {"search":"ProductList_search__59iQH","image":"ProductList_image__jnnXA","header":"ProductList_header__vQi77"};